export var AccountType;
(function (AccountType) {
    AccountType[AccountType["INCOME"] = 1] = "INCOME";
    AccountType[AccountType["COST_OF_GOODS_SOLD"] = 2] = "COST_OF_GOODS_SOLD";
    AccountType[AccountType["EXPENSE"] = 3] = "EXPENSE";
    AccountType[AccountType["ASSET"] = 4] = "ASSET";
    AccountType[AccountType["LIABILITY"] = 5] = "LIABILITY";
    AccountType[AccountType["EQUITY"] = 6] = "EQUITY";
})(AccountType || (AccountType = {}));
//# sourceMappingURL=account-type.js.map